import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0"
}
const _hoisted_2 = {
  key: 1,
  class: "compact-title"
}
const _hoisted_3 = {
  key: 2,
  class: "targets-list-chips"
}
const _hoisted_4 = {
  key: 0,
  class: "text-label"
}
const _hoisted_5 = {
  key: 3,
  class: "targets-list-list"
}
const _hoisted_6 = {
  key: 0,
  class: "text-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcCounterBadge = _resolveComponent("RcCounterBadge")!
  const _component_RcTag = _resolveComponent("RcTag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["targets-list-main", { 'compact': $props.compact }])
  }, [
    (!$props.compact)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.matching.title', { n: $options.clustersRenderList.length })), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.matching.selectedClusters')), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createVNode(_component_RcCounterBadge, {
            count: $options.clustersRenderList.length,
            type: "inactive"
          }, null, 8, ["count"])
        ])),
    _cache[4] || (_cache[4] = _createTextVNode()),
    ($props.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.clustersRenderList, (cluster) => {
            return (_openBlock(), _createBlock(_component_RcTag, {
              key: cluster.name,
              type: "inactive",
              class: "do-not-shrink"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cluster.name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (!$options.clustersRenderList.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.emptyLabel || _ctx.t('fleet.clusterTargets.rules.matching.empty')), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.clustersRenderList, (cluster) => {
            return (_openBlock(), _createElementBlock("span", {
              key: cluster.name,
              class: "row"
            }, [
              _createVNode(_component_router_link, {
                to: cluster.detailLocation,
                target: "_blank",
                class: "link-main"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(cluster.name) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("i", {
                    class: "link-icon icon icon-external-link",
                    "aria-hidden": "true"
                  }, null, -1))
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (!$options.clustersRenderList.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.emptyLabel || _ctx.t('fleet.clusterTargets.rules.matching.empty')), 1))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}